import ElementGroup from '@/domain/scene/generic/ElementGroup.js'

const TRAIN_GROUP_NAME = 'TrainGroup'
const TRAIN_GROUP_INIT_X_REL = 0
const TRAIN_GROUP_INIT_Y_REL = 0

export default class TrainGroup extends ElementGroup {
  constructor () {
    super(
      TRAIN_GROUP_NAME,
      TRAIN_GROUP_INIT_X_REL,
      TRAIN_GROUP_INIT_Y_REL
    )
  }

  setDraggable (sceneWidth) {
    let minPos = 0
    let maxPos = sceneWidth

    let trainGroupDragBoundFunc = function (pos) {
      let newX = pos.x
      if (newX < minPos) {
        newX = minPos
      }
      if (newX > maxPos) {
        newX = maxPos
      }
      return {
        x: newX,
        y: this.absolutePosition().y
      }
    }

    super.setDraggable(true, trainGroupDragBoundFunc)
  }
}
